const STORAGE_KEY = "hasOnboardedWorkspaces";

function getOnboardedWorkspaces(): string[] {
  if (typeof window === "undefined") return [];
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
}

function updateOnboardedWorkspaces(workspace: string) {
  if (typeof window === "undefined") return;

  const onboarded = getOnboardedWorkspaces();

  if (!onboarded.includes(workspace)) {
    const updated = [...onboarded, workspace];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  }
}

export { getOnboardedWorkspaces, updateOnboardedWorkspaces };
